export const ONBOARDING_ROUTE_NAMES = {
  ENTRY: 'onboardingEntry',
  PASSWORD: 'onboardingPassword',
  PAYMENTS: 'onboardingPayments',
  DONE: 'onboardingDone',
  TOKEN_EXPIRED: 'tokenExpired',
}
